import { IApplicationState } from '../../types/redux';

const EMPTY_BREADCRUMBS: never[] = [];

export function getBreadcrumbs(state: IApplicationState) {
  return state.developerV2?.seo?.breadcrumbs || EMPTY_BREADCRUMBS;
}
